<template>
  <div class="employment">
    <h2>Employment History</h2>
    <p class="highlight-text">Please provide employment details of your two most recent  roles.</p>
    <!-- Form -->
    <b-form>
      <!-- Current or most recent employer -->
      <h4>Current/Most Recent Employer</h4>
      <!-- Company Name -->
      <b-form-group
        label="Company Name*"
      >
        <b-form-input
          :value="recruit.previousEmployment.currEmployer"
          @input="handleInput('currEmployer', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currEmployer.$error && recruit.previousEmployment.currEmployer,
            'is-invalid': $v.recruit.previousEmployment.currEmployer.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Job Title -->
      <b-form-group
        label="Job Title*"
      >
        <b-form-input
          :value="recruit.previousEmployment.currJobTitle"
          @input="handleInput('currJobTitle', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currJobTitle.$error && recruit.previousEmployment.currJobTitle,
            'is-invalid': $v.recruit.previousEmployment.currJobTitle.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Start Date -->
      <b-form-group
        label="Start Date*"
      >
        <b-form-input
          type="date"
          :value="recruit.previousEmployment.currStartDate"
          @input="handleInput('currStartDate', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currStartDate.$error && recruit.previousEmployment.currStartDate,
            'is-invalid': $v.recruit.previousEmployment.currStartDate.$error 
          }"
          :max="getToday()"
        ></b-form-input>
      </b-form-group>
      <!-- End Date -->
      <b-form-group
        label="End Date"
      >
        <b-form-input
          type="date"
          :value="recruit.previousEmployment.currEndDate"
          @input="handleInput('currEndDate', $event, true)"
          :max="getToday()"
          :disabled="recruit.previousEmployment.currStillEmployed"
        ></b-form-input>
      </b-form-group>
      <!-- Still at current check -->
      <b-form-group>
        <div class="checkbox checkbox-custom">
          <input id="current-still" 
            name="current-still" 
            type="checkbox" 
            :value="recruit.previousEmployment.currStillEmployed"
            v-model="currStillEmployed"
            required
            @change="handleInput('currStillEmployed', $event.target.checked, true)"
          >
          <label for="current-still">Still in current role</label>
        </div>
      </b-form-group>
      <!-- Salary and Benefits -->
      <b-form-group
        label="Salary and Benefits*"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.currSalary"
          @input="handleInput('currSalary', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currSalary.$error && recruit.previousEmployment.currSalary,
            'is-invalid': $v.recruit.previousEmployment.currSalary.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Duties and Responsibilities -->
      <b-form-group
        label="Duties and Responsibilities*"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.currDuties"
          @input="handleInput('currDuties', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currDuties.$error && recruit.previousEmployment.currDuties,
            'is-invalid': $v.recruit.previousEmployment.currDuties.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Reason for Leaving -->
      <b-form-group
        label="Reason for Leaving*"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.currWhyLeave"
          @input="handleInput('currWhyLeave', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currWhyLeave.$error && recruit.previousEmployment.currWhyLeave,
            'is-invalid': $v.recruit.previousEmployment.currWhyLeave.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Notice Period -->
      <b-form-group
        label="What is the notice period?*"
      >
        <b-form-input
          :value="recruit.previousEmployment.currNotice"
          @input="handleInput('currNotice', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currNotice.$error && recruit.previousEmployment.currNotice,
            'is-invalid': $v.recruit.previousEmployment.currNotice.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Full or Part time -->
      <b-form-group
        label="Was the position full or part time*"
      >
        <b-form-input
          :value="recruit.previousEmployment.currFullPartTime"
          @input="handleInput('currFullPartTime', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currFullPartTime.$error && recruit.previousEmployment.currFullPartTime,
            'is-invalid': $v.recruit.previousEmployment.currFullPartTime.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Hours per week -->
      <b-form-group
        label="Number of hours per week?*"
      >
        <b-form-input
          :value="recruit.previousEmployment.currNumHours"
          @input="handleInput('currNumHours', $event, true, true)"
          :class="{
            'is-valid': !$v.recruit.previousEmployment.currNumHours.$error && recruit.previousEmployment.currNumHours,
            'is-invalid': $v.recruit.previousEmployment.currNumHours.$error
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Previous employer -->
      <h4>Previous Employer</h4>
      <!-- Company Name -->
      <b-form-group
        label="Company Name"
      >
        <b-form-input
          :value="recruit.previousEmployment.preEmployer"
          @input="handleInput('preEmployer', $event, true)"
        ></b-form-input>
      </b-form-group>
      <!-- Job Title -->
      <b-form-group
        label="Job Title"
      >
        <b-form-input
          :value="recruit.previousEmployment.preJobTitle"
          @input="handleInput('preJobTitle', $event, true)"
        ></b-form-input>
      </b-form-group>
      <!-- Start Date -->
      <b-form-group
        label="Start Date"
      >
        <b-form-input
          type="date"
          :value="recruit.previousEmployment.preDatesFrom"
          @input="handleInput('preDatesFrom', $event, true)"
          :max="getToday()"
        ></b-form-input>
      </b-form-group>
      <!-- End Date -->
      <b-form-group
        label="End Date"
      >
        <b-form-input
          type="date"
          :value="recruit.previousEmployment.preDatesTo"
          @input="handleInput('preDatesTo', $event, true)"
          :max="getToday()"
        ></b-form-input>
      </b-form-group>
      <!-- Salary and Benefits -->
      <b-form-group
        label="Salary and Benefits"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.preSalary"
          @input="handleInput('preSalary', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Duties and Responsibilities -->
      <b-form-group
        label="Duties and Responsibilities"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.preDuties"
          @input="handleInput('preDuties', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Reason for Leaving -->
      <b-form-group
        label="Reason for Leaving"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.preWhyLeave"
          @input="handleInput('preWhyLeave', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- Other experience -->
      <b-form-group
        label="Please give details of any other relevant experience (training courses, voluntary work, other) to support your application and further highlight your 'Sales Ability' or 'Outstanding Client Care'"
      >
        <b-form-textarea
          :value="recruit.previousEmployment.otherExp"
          @input="handleInput('otherExp', $event, true)"
        ></b-form-textarea>
      </b-form-group>
      <!-- <BtnMain @btnClicked="handleProgress" text="Save and progress" btnClass="progress-btn" variant="dark" /> -->
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
// import BtnMain from '../../components/BtnMain'
import { required } from 'vuelidate/lib/validators'
import dayjs from "dayjs";
export default {
  components: {
    // BtnMain
  },
  computed: {
    ...mapState({recruit: state => state.authStore.recruit}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen'
    })
  },
  data () {
    return {
      currStillEmployed: ''
    }
  },
  mounted () {
    this.$v.$touch()
    // Set currStillEmployed on load - this is required to display checked boxes in accordance with whats saved in mongo
    setTimeout(() => {
      this.currStillEmployed = this.getRecruit.previousEmployment.currStillEmployed
    }, 1000)
  },
  updated () {
    // Pass validation status to vuex
    const validationData = {
      section: 'employment',
      status: !this.$v.recruit.$invalid
    }
    this.updateApplicationCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateRecruitAction: 'authStore/updateRecruitAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      updateApplicationCompleteAction: 'authStore/updateApplicationCompleteAction'
    }),
    handleInput (input, e, nested, required) {
      // handle nested input
      const nestedItem = {
        category: 'previousEmployment',
        input
      }
      this.updateForm(nestedItem, e, nested)
       // If field is required run veulidate validation - to apply classes to input not to prevent user from saving
      if (required) {
        this.$v.recruit.previousEmployment[input].$touch()
      }
    },
    updateForm,
    getToday(){
      return dayjs().format("YYYY-MM-DD")
    }
  },
  validations: {
    recruit: {
      previousEmployment: {
        currEmployer: {
          required: required
        },
        currJobTitle: {
          required: required
        },
        currStartDate: {
          required: required,
        },
        currSalary: {
          required: required
        },
        currDuties: {
          required: required
        },
        currWhyLeave: {
          required: required
        },
        currNotice: {
          required: required
        },
        currFullPartTime: {
          required: required
        },
        currNumHours: {
          required: required
        },
      }
    }
  }
}
</script>

<style scoped>
.date-error-text{
  color: red;
}
</style>